export const ENV = {
  ALPHA: 'alpha',
  STAGING: 'staging',
  CUSTOMER: 'customer',
};

/* Selected environment — set via VITE_APP_ENV at build time, falls back to customer */
export const ENVIRONMENT = import.meta.env.VITE_APP_ENV || ENV.CUSTOMER;
/* */

const configAlpha = {
  APOLLO_HOST_URL: 'https://esim-server2.projects.itrvn.com/',
  SOCKET_URL: 'https://esim-server2.projects.itrvn.com/',
};

const configStaging = {
  APOLLO_HOST_URL: 'https://graphql.devel2.backend.esim.me/',
  SOCKET_URL: 'https://graphql.devel2.backend.esim.me/',
};

const configCustomer = {
  APOLLO_HOST_URL: 'https://graphql.backend.esim.me/',
  SOCKET_URL: 'https://graphql.backend.esim.me/',
};

const generateConfig = () => {
  switch (ENVIRONMENT) {
    case ENV.ALPHA:
      return configAlpha;
    case ENV.STAGING:
      return configStaging;
    case ENV.CUSTOMER:
      return configCustomer;
    default:
      return configAlpha;
  }
};

const CONFIG = {
  ...generateConfig(),
  /* VITE_GRAPHQL_URL / VITE_SOCKET_URL set at build time override the APP_ENV preset above */
  ...(import.meta.env.VITE_GRAPHQL_URL && { APOLLO_HOST_URL: import.meta.env.VITE_GRAPHQL_URL }),
  ...(import.meta.env.VITE_SOCKET_URL && { SOCKET_URL: import.meta.env.VITE_SOCKET_URL }),
};

export default CONFIG;
